/* eslint-disable camelcase */
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useSnapshot } from 'valtio';

import * as Pioneer from 'pioneer';
import { poiStore } from '../managers/globalState';
import globalRefs from '../managers/globalRefs';
import { ProjectLogin } from '../components/overlays/gmap_overlay';
import { HOME_PAGE } from '../config/constants';
import { loadPoi } from '../helpers/processPoI';
import { hideLoading, showLoading } from '../components/loading';

const PoiDetail = () => {
	const { poiParam } = useParams();
	const navigate = useNavigate();
	const [loginRequest, setLoginRequest] = useState(null);
	const { pois } = useSnapshot(poiStore.state);
	const isLoading = useRef(null);

	const currentPoi = pois && pois.length > 0 ? pois.find(({ external_id }) => external_id === poiParam) : null;

	// useEffect for when event changes.
	useEffect(() => {
		// Set variables.
		const { pioneer } = globalRefs;
		const { external_id, type } = currentPoi || {};
		const alreadyLoading = isLoading.current === external_id;
		// console.log("PoiDetail", currentPoi, alreadyLoading)

		if (!currentPoi || alreadyLoading) {
			return;
		}

		const controller = new AbortController();
		let resolveLogin;
		const authenticate = () => new Promise(resolve => {
			resolveLogin = resolve;
			setLoginRequest({ resolve });
		});

		// Set isLoading.
		isLoading.current = external_id;

		const loadType = 'event';
		// Hide the previous image and details while authentication is pending.
		hideLoading(loadType);
		poiStore.setGlobalState({ currentPoi: null });
		const earthPatch = pioneer.getScene('main').getEntity('earth_patch');
		const patchComponent = earthPatch?.getComponent(Pioneer.SpheroidLODComponent, 'poi_patch_lod');
		patchComponent?.setEnabled(false);

		// Load the video if it is animated or static if not.
		loadPoi(currentPoi, {
			authenticate,
			signal: controller.signal,
			onAuthorized: () => {
				showLoading(loadType);
			},
			onReady: () => {
				poiStore.setGlobalState({ currentPoi });
			}
		})
			// NOTE: Currently assuming global static events are not possible.
			.then(() => {
				if (controller.signal.aborted) return;
				// Check if event is still loading.
				if (isLoading.current) {
					// Hide loading.
					hideLoading(loadType);
				}

				// Set isLoading to false.
				isLoading.current = false;
			}).catch(e => {
				if (controller.signal.aborted) return;
				hideLoading(loadType);
				isLoading.current = false;
				console.error('Error loading POI: ', e);
			});

		// On currentVideo change / unmount disable the earth patch.
		return () => {
			controller.abort();
			if (resolveLogin) resolveLogin(false);
			setLoginRequest(null);
			isLoading.current = null;
			hideLoading(loadType);
			// console.log("after load poi", patchComponent)
			if (patchComponent) {
				patchComponent.setEnabled(false)
			}
		};
	}, [currentPoi]);

	// useEffect to set current event to null and disable patch when leaving event detail view.
	// eslint-disable-next-line arrow-body-style
	useEffect(() => {
		return () => {
			const { pioneer } = globalRefs;

			const earthPatch = pioneer.getScene('main').getEntity('earth_patch');
			const patchComponent = earthPatch?.getComponent(Pioneer.SpheroidLODComponent, 'poi_patch_lod');

			// Set isLoading to null and hide loading.
			isLoading.current = null;
			hideLoading('event');

			// Disable the patch.
			if (patchComponent) {
				patchComponent.setEnabled(false);
			}

			// Reset global states.
			poiStore.setGlobalState({ currentPoi: null });

		};
	}, []);


	return loginRequest ? (
		<ProjectLogin
			onSuccess={() => {
				loginRequest.resolve(true);
				setLoginRequest(null);
			}}
			onCancel={() => {
				loginRequest.resolve(false);
				setLoginRequest(null);
				navigate(HOME_PAGE);
			}}
		/>
	) : null;
};

export default PoiDetail;
